import api from "./api";

// Calendário: feriados (CRUD + upload XLSX) + expediente (horário comercial).
const calendarService = {
  listHolidays: (year, includeInactive) =>
    api
      .get("/calendar/holidays", { params: { year, include_inactive: includeInactive } })
      .then((r) => r.data),
  createHoliday: (payload) => api.post("/calendar/holidays", payload).then((r) => r.data),
  updateHoliday: (id, payload) => api.put(`/calendar/holidays/${id}`, payload).then((r) => r.data),
  deleteHoliday: (id) => api.delete(`/calendar/holidays/${id}`).then((r) => r.data),
  uploadHolidays: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    // Sem este header, o axios usa o default application/json da instância e o
    // backend devolve 422. (mesmo padrão dos uploads de anexo/avatar)
    return api
      .post("/calendar/holidays/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
  getBusinessHours: () => api.get("/calendar/business-hours").then((r) => r.data),
  setBusinessHours: (rows) => api.put("/calendar/business-hours", rows).then((r) => r.data),
};

export default calendarService;
